import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { AI_PROMPT } = STEP_IDENTIFIER_NAME;

export const aiPrompt: StepConfig = {
	name: AI_PROMPT,
	isAuthenticationRequired: false,
	isEnabled: (fcm) => fcm.starterAIPrompt.isEnabled,
};
